import { render, staticRenderFns } from "./EffectsPanel.vue?vue&type=template&id=40f36e3a"
import script from "./EffectsPanel.vue?vue&type=script&lang=js"
export * from "./EffectsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports